import { Input, useId, Label, mergeClasses, InputOnChangeData } from '@fluentui/react-components';
import { useBaseInputFieldStyles } from './BaseInputField.styles';
import { IInputFieldProps } from './BaseInputField.types';
import { ChangeEvent } from 'react';

const InputField = (props: IInputFieldProps) => {
    const {
        name,
        value,
        defaultValue,
        label,
        placeholder,
        autoComplete,
        className,
        style,
        required,
        disabled,
        onChange,
        onExitFocus
    } = props;

    const inputId = `input-${name}`;
    const uniqueId = useId(`input-${name}`);

    const styles = useBaseInputFieldStyles();

    const handleChange = (_: ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        onChange(data.value);
    };

    return (
        <div className={className ? mergeClasses(styles.root, className) : styles.root}>
            <div>
                <Label htmlFor={inputId} className={styles.label}>
                    {label}
                </Label>
                {required && <span className={styles.requiredAsterisk}>*</span>}
            </div>
            <Input
                id={uniqueId}
                data-testid={inputId}
                placeholder={placeholder}
                defaultValue={defaultValue}
                required={required}
                disabled={disabled}
                className={styles.inputField}
                style={style}
                name={name}
                value={value}
                onChange={handleChange}
                onBlur={onExitFocus}
                autoComplete={autoComplete}
            />
        </div>
    );
};

export default InputField;
